import React from 'react';
import PropTypes from 'prop-types';

import Select from 'zignal-landscape/lib/Select';
import themeable from 'zignal-landscape/lib/themeable';

import {getCounts, formatValues} from './helpers';

const SourceSelector = ({
  data,
  onSelectSource,
  selectedSource = 'allSources'
}) => {

  const onChangeSource = (source) => {
    onSelectSource(source.value);
  };

  const formattedValues = formatValues(getCounts(data));
  const selected = formattedValues.find(v => v.value === selectedSource);

  return (
    <Select
      options={formattedValues}
      placeholder={formattedValues[0]?.label}
      defaultValue={selected}
      onChange={value => onChangeSource(value)}
      selectStyles={{
        singleValue: base => ({
          ...base,
          padding: 0,
          lineHeight: 'inherit',
          color: 'rgb(180, 191, 214)'
        }),
        valueContainer: base => ({ ...base, padding: '0 7px' })
      }}
    />
  );
};

SourceSelector.propTypes = {
  data: PropTypes.array.isRequired,
  onSelectSource: PropTypes.func.isRequired,
  selectedSource: PropTypes.string,
};

export default themeable(SourceSelector);
